// extracted by mini-css-extract-plugin
module.exports = {"list-item-box":"QE4rRznJU69edx4j-RryV","sales-type-title":"_3dn_yW02h0YGHK9SFFDv8d"};